import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const qrCode = createAsyncThunk('qrCode', async (data) => {

    try {
        const res = await axios({

            method: 'post',
            url: process.env.REACT_APP_API_URL + `link_qrcode_generate`,
            data: {
                "short_url": data?.short_url
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const qrCodeSlice = createSlice({
    name: 'qrCode',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(qrCode.fulfilled, (state, action) => {
            if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(qrCode.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default qrCodeSlice.reducer; 